import React, {memo} from "react";
import {Typography, Modal } from '@mui/material';

import ButtonMain from "../button/Button_main";
import './Modal_style.scss'

import trash from '../../assets/trash-large.svg'

const ModalDelete = (props) => {

    const deleteAction = () => {

        if(props.delType == 1){
            props.delFuncSingle()
        }
        else{
            props.delFuncMultiple()
        }

    }

    return(
            <Modal
                open={props.openDelete}
                aria-labelledby="modal-modal-title"
            >
                <div className="modal-container modal-view max-w-25">
                    <div className="modal-text-center">
                        <img src={trash} alt="trash" className="popup-icon-lg mb-5-modal modal-mt-16"/>
                    </div>
                    <Typography align="center" id="modal-modal-title" className="mb-2-modal" variant="textheader3" component="div">
                        {props.delType == 1 ? 'Delete File' :'Delete Files'}
                    </Typography>
                    <Typography align="center" component={'div'} variant="textBaseLight" className="modal-mb-8">
                        Are you sure you want to delete {props.delType == 1 ? 'this file' : `${props.selectedCount === 1 ? 'this file': `${props.selectedCount} files`} ` }
                    </Typography>
                    <div className="modal-footer-center mt-5-modal pt-5-modal border-top-modal">
                        <ButtonMain 
                            variant='primaryOutline' 
                            type='button' 
                            disabled={false} 
                            name='Cancel'
                            class='modal-capitalize'
                            onClick={()=>props.setOpenDelete(false)}
                        />
                        <ButtonMain 
                            variant='red' 
                            type='button' 
                            disabled={false} 
                            name='Delete'
                            class='modal-capitalize'
                            onClick={deleteAction}
                        />
                    </div>
                </div>
            </Modal>
    )
}

export default memo(ModalDelete);